<p-dialog [header]="'Scope Audit: ' + scopeName" [(visible)]="isShowScopeAuditModal" [draggable]="false"
          [style]="{ width: '100vw', height: '95vh' }" (onHide)="closeScopeAuditModal()" [modal]="true"
          id="scopeAuditModal">
  <app-scope-audit-trial [auditTrailData]="auditData">
  </app-scope-audit-trial>
</p-dialog>
